<template>
    <div class="interaction-c" data-spm="Comments" v-if="isShow">
        <div class="header">
            <div class="left">
                {{headerTitle}}
                <span class="count" v-if="count">{{count}}</span>
            </div>
            <a class="right" :href="allHref">
                全部
                <img :src="nextIcon"/>
            </a>
        </div>
        <!-- 评论流 -->
        <div v-if="filterCommentList.length" class="comment-list-c">
            <div class="banner-swiper">
                <a v-for="item in filterCommentList" :key="item.id" class="banner-item" :href="commentHref" data-spm-data="2">
                    <img :src="item.avatar"/>
                    <CommentText :text="item.richContent" class="item-content"/>
                </a>
            </div>
        </div>
        <!-- 无评论 -->
        <div v-else-if="!isBanned" class="comment-empty" @click="goComment" data-spm-type="resource" data-spm-content="|||||" data-spm-data="3">
            <div class="no-comment-tips">还没有人评论过，快来抢首评</div>
            <div class="divide-line"></div>
            <div class="edit-icon"></div>
            <div class="write-comment">写评论</div>
        </div>
        <!-- 视野+讨论流 -->
        <div v-if="sliceVisionDiscussList.length" class="vision-discuss-c">
            <a 
                v-for="item in sliceVisionDiscussList" 
                :key="item.id" 
                class="item"
                :href="hotDiscussHref"
                data-spm-data="4"
            >
                <img :src="getVisionDiscussIcon(item)"/>
                <div class="line"></div>
                <div class="item-content">{{item.title}}</div>
            </a>
        </div>
    </div>
</template>

<script>
import nextIcon from '@/less/images/icon_next_empty44@2x.png'
import discussIcon from '@/less/images/discuss_vs.png'
import visionIcon from '@/less/images/vision_question.png'
import { getComments,fetchCommentStatus } from '@/js/article-main/request/api';
import { getOdinData } from '@/js/request/odinRequest'
import { getOdinResourceIdMap } from "@/config/odinResourceIds"
import PicUtils from '@/utils/pic-util'
import CommentText from 'common-components/lib/commentText/index'
import 'common-components/lib/commentText/index.css'

export default {
    name: "interaciton",
    data () {
        return {
            nextIcon,
            discussIcon,
            visionIcon,
            headerTitle: '评论',
            commentCount: 0, // 过审评论数
            fakeCommentCount: 0, // 假评论数
            users: {},
            commentList: [], // 评论流
            visionDiscussList: [], // 视野流+讨论流
             //滚动组件参数
            slideParam: {
                wrapperSelector: ".banner-swiper",
                slideTime: 1000 * 5, //单帧停留时间，目前为4秒
                animateTime: 500, //动画时间，目前为500毫秒
                itemSelector: ".banner-item",
            },
            commentBaseUrl: `/cm/${cfgs.newsId}_${cfgs.media_id}`,
            articleVoteId: '',// 正文中“投票”对应的讨论id
            isBanned: false, // 禁止评论
            pageNo: 1, // 页码
            pageSize: 3, // 每页条数
        }
    },
    components: {
        CommentText
    },
    computed: {
        // 禁止评论+没有互动 不展示该区块
        isShow() {
            return !(this.isBanned && !this.sliceVisionDiscussList?.length)
        },
        allHref() {
            if(this.isBanned ) return `${this.commentBaseUrl}?tab=2&voteId=${this.articleVoteId}`// tab=2 热门讨论
            return this.articleVoteId ? `${this.commentBaseUrl}?voteId=${this.articleVoteId}` : this.commentBaseUrl
        },
        commentHref() {
            return this.articleVoteId ? `${this.commentBaseUrl}?voteId=${this.articleVoteId}` : `${this.commentBaseUrl}`
        },
        hotDiscussHref() {
            return this.articleVoteId ? `${this.commentBaseUrl}?tab=2&voteId=${this.articleVoteId}` : `${this.commentBaseUrl}?tab=2` // tab=2 热门讨论
        },
        count() {
            return this.commentCount + this.fakeCommentCount
        },
        sliceVisionDiscussList() {
            return this.commentCount ? this.visionDiscussList.slice(0,1) : this.visionDiscussList.slice(0,2)
        },
        filterCommentList() {
            return this.commentList.filter(item => item?.content) || []
        },
    },
    mounted() {
        window?.eventBus?.$on('addFakeComment',this.addFakeComment)
        this.getCommentStatus()
        this.getCommentsList()
        // 文中不存在“投票”功能卡,立即请求
        if(!document.querySelectorAll('mp-plugin[data-type="66"]').length) {
            this.getDiscussVisionList()
        }else {
            window.eventBus.$on('renderVoteCardFinish',this.getDiscussVisionList)
        }
    },
    methods: {
        // 初始化轮播
        swiperVInit() {
            const SlideV = window.MptcfeUtils.SlideV;
            new SlideV(this.slideParam);
        },
        // 是否支持评论
        async getCommentStatus() {
            window.sohuSpm?.sendAction({
                acode: 10674,
                clkParam: `from:commentStatus;flag:s`,
            });
            const p = {
                source_id: `mp_${window.cfgs?.newsId}`
            }
            const res = await fetchCommentStatus(p)
            window.sohuSpm?.sendAction({
                acode: 10674,
                clkParam: `from:commentStatus;flag:r`,
            });
            if(res.code == 200 && res.data === false) {
                this.isBanned = true // 禁止评论
                this.headerTitle = '热门讨论'
            }
        },
        async getCommentsList() {
            const p = {
                sourceId: `mp_${cfgs.newsId}`,
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                type: 0,
                accountId: cfgs.media_id,
            }
            try {
                const res = await getComments(p)
                this.pageNo++
                if(res.code == 1) {
                    this.commentList = res?.data?.comments || []
                    this.commentCount = res?.data?.outerCmtSum + (res?.data?.noAuditedSum || 0)
                    this.users = res?.data?.users
                    this.commentList.forEach(item => {
                        if(this.users[item.userId]?.avatar) {
                            item.avatar = PicUtils.setPicSize(this.users[item.userId].avatar,56,56)
                        }else {
                            item.avatar = '//statics.itc.cn/mobile/ucenter/images/ic_home_photo_gray.png'
                        }
                    })
                    this.$nextTick(()=>{
                        window.sohuSpm.domDidChange({target: 'Comments'});  
                        if(this.filterCommentList.length > 1) {
                            this.swiperVInit();
                        }        
                    })
                }
                const isHasComment = res?.data?.comments?.length > Math.floor(this.pageSize / 2)
                const isNoContentComment = this.filterCommentList.length === 0
                if(isNoContentComment && isHasComment){
                    this.getCommentsList()
                }
                return this.commentList
            } catch (error) {
                console.log('评论外显组件获取评论列表失败',error)
            }

        },
        async getDiscussVisionList(voteCaradInfo) {
            window.sohuSpm?.sendAction({
                acode: 10674,
                clkParam: `from:discussList;flag:s`,
            });
            this.articleVoteId = voteCaradInfo?.fields?.voteId || '' // 正文“投票”对应的讨论id
            const tplCompKey = "discussVisionRec"
            const idsMap = getOdinResourceIdMap(tplCompKey)
                const spmObj = window?.sohuSpm?.getCodes()
                const params = {
                    tplCompKey,
                    adInfo: idsMap.adInfo,
                    spmCCode: idsMap.spmCCode,
                    resourceId: idsMap.resourceId,
                    content: {
                        page: 1,
                        size: 2,
                        productId: idsMap.productId,
                        productType: idsMap.productType,
                        spm: `${spmObj?.a}.${spmObj?.b}.${idsMap?.spmCCode}`
                    },
                    context: { 
                        mpId: window?.cfgs?.newsId,
                        voteId: this.articleVoteId
                    }
                }
            const res = await getOdinData(params)
            window.sohuSpm?.sendAction({
                acode: 10674,
                clkParam: `from:discussList;flag:r`,
            });
            this.visionDiscussList = res?.list || []
            this.$nextTick(()=>{
                window.sohuSpm?.domDidChange({target: 'Comments'});         
            })
        },
        goComment() {
            window.sohuSpm?.sendAction({ acode: '10673' })
            window.eventBus?.$emit('showCommentTextarea')
        },
        getVisionDiscussIcon(item) {
            if(item?.type == 7) return this.visionIcon
            return this.discussIcon
        },
        // 添加假评论
        addFakeComment(data) {
            this.fakeCommentCount = this.fakeCommentCount + 1
            let fakeComment = {
                ...data,
                avatar: window.userInfo?.avatar,
            }
            // 评论数在0-2内进行假显示，不然轮播会有问题
            if(this.commentList.length < 2) {
                this.commentList.push(fakeComment)
                this.$nextTick(()=>{
                    if(this.filterCommentList.length>1)this.swiperVInit()
                })
            }
        }
    },

}
</script>

<style lang="less" scoped>
    .interaction-c {
        border-bottom: solid 16px #F5F5F5; /*px*/
        padding: 26px 26px 0; /*px*/
        box-sizing: border-box;
        font-family: PingFangSC, PingFang SC;
        .header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 44px; /*px*/
            .left {
                font-weight: 500;
                font-size: 36px; /*px*/
                color: #111111;
                font-family: PingFangSC, PingFang SC;
            }
            .right {
                display: flex;
                align-items: center;
                font-weight: 400;
                font-size: 28px;/*px*/
                color: #999999;
                font-family: PingFangSC, PingFang SC;
                img {
                    width: 28px;/*px*/
                    height: 28px;/*px*/
                    margin-left: 4px; /*px*/
                }
            }
        }
        .comment-empty {
            height: 112px; /*px*/
            font-size: 28px; /*px*/
            color: #999999;
            padding: 32px 0 40px; /*px*/
            display: flex;
            align-items: center;
            box-sizing: border-box;
            justify-content: center;
            .no-comment-tips {
                font-size: 28px; /*px*/
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                color: #999999;
                line-height: 40px; /*px*/
            }
            .divide-line {
                width: 2px;/*px*/
                height: 24px;/*px*/
                background: #EBEBEB;
                margin: 0px 16px;/*px*/
            }
            .edit-icon {
                width: 28px;/*px*/
                height: 28px;/*px*/
                background: url('../../less/images/icon_edit_666666.png') no-repeat center;
                background-size: contain;
                margin-right: 8px;/*px*/
            }
            .write-comment {
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 28px; /*px*/
                color: #666666;
                line-height: 40px; /*px*/
                text-align: justify;
                font-style: normal;
            }
        }
        .vision-discuss-c {
            background: #F8F8F8;
            margin-bottom: 26px;/*px*/
            margin-top: 32px;/*px*/
            .item {
                height: 72px; /*px*/
                display: flex;
                align-items: center;
                font-weight: 400;
                font-size: 32px; /*px*/
                color: #111111;
                padding: 0 16px; /*px*/
                img {
                    width: 40px; /*px*/
                    height: 40px; /*px*/
                }
                .line {
                    width: 2px;/*px*/
                    height: 24px;/*px*/
                    background: #CCCCCC;
                    margin: 0 16px;/*px*/
                }
                .item-content {
                    line-height: 48px; /*px*/
                    display: -webkit-box;
                    /* autoprefixer:off */
                    -webkit-box-orient: vertical;
                    /* autoprefixer:on */
                    -webkit-line-clamp: 1;
                    overflow: hidden;
                }
            }
        }
        .comment-list-c {
            margin: 32px 0 32px; /*px*/
            .banner-swiper {
                height: 96px;/*px*/
                overflow: hidden;
                .banner-item {
                    position: relative;
                    height: 96px;/*px*/
                    display: flex;
                    align-items: center;
                    font-size: 32px; /*px*/
                    color: #111111;
                    img {
                        width: 56px;/*px*/
                        height: 56px;/*px*/
                        border-radius: 50%;
                        margin-right: 16px;/*px*/
                    }
                    .item-content {
                        line-height: 48px; /*px*/
                        display: -webkit-box;
                        /* autoprefixer:off */
                        -webkit-box-orient: vertical;
                        /* autoprefixer:on */
                        -webkit-line-clamp: 2;
                        overflow: hidden;
                        max-height: 96px; /*px*/
                        /deep/ .emoji{
                            font-size: 42px;/*px*/
                            vertical-align: text-bottom;
                            display: inline-flex;
                            align-items: center;
                            justify-content: center;
                        }
                        /deep/ .comment-at{
                            color: #143CA8;
                        }
                    }
                }
            }
        }
    }
</style>